import { combineEpics } from 'redux-observable';
import { filter, mapTo, tap, withLatestFrom } from 'rxjs/operators';
import { getName } from '../user/helpers';
import { isActionOf, makeEpic } from '../utils';
import { openFreshchat, reportProblem } from './actions';

const openReportModal = makeEpic((action$, state$) =>
  action$.pipe(
    filter(isActionOf(reportProblem)),
    withLatestFrom(state$),
    tap(([_, state]) => {
      window.fcWidget?.close();
      const { organization, organizationGroup, user } = state;

      window.FreshworksWidget('identify', 'ticketForm', {
        name: getName(user),
        email: user.email,
      });
      window.FreshworksWidget('prefill', 'ticketForm', {
        custom_fields: {
          cf_django_org_idenv: String(organization.id),
          cf_is_production: !!organizationGroup.current?.isProduction,
          cf_deployment: organizationGroup.current?.deploymentLocation,
        },
      });
      window.FreshworksWidget('hide', 'ticketForm', [
        'custom_fields.cf_django_org_idenv',
        'custom_fields.cf_is_production',
        'custom_fields.cf_deployment',
      ]);

      window.FreshworksWidget('open', 'ticketForm');
    }),
    mapTo({ type: 'EMPTY_ACTION' })
  )
);

const openFreshchatWidget = makeEpic((action$, state$) =>
  action$.pipe(
    filter(isActionOf(openFreshchat)),
    withLatestFrom(state$),
    tap(([_, state]) => {
      window.FreshworksWidget('close', 'ticketForm');
      const { organization, organizationGroup, user } = state;

      window.initFreshchat?.(() => {
        window.fcWidget?.setExternalId(String(user.id));
        window.fcWidget?.user.setFirstName(getName(user));
        if (user.email) {
          window.fcWidget?.user.setEmail(user.email);
        }
        window.fcWidget?.conversation?.setConversationProperties({
          cf_django_org_id: String(organization.id),
          cf_is_production: !!organizationGroup.current?.isProduction,
          cf_deployment: organizationGroup.current?.deploymentLocation ?? '',
        });
        window.fcWidget?.open();
      });
    }),
    mapTo({ type: 'EMPTY_ACTION' })
  )
);

export default combineEpics(openReportModal, openFreshchatWidget);
